import type { GetCourseDetail200SectionsItemLecturesItem } from './getCourseDetail200SectionsItemLecturesItem';

export type GetCourseDetail200SectionsItem = {
  /**
   * 섹션 설명
   * @nullable
   */
  description?: string | null;
  /** 섹션 ID */
  id: string;
  /** 섹션에 포함된 강의 목록 */
  lectures: GetCourseDetail200SectionsItemLecturesItem[];
  /** 섹션 순서 */
  order: number;
  /** 섹션 제목 */
  title: string;
};
